import React from 'react';
import Pagination from 'react-js-pagination';

class Paginator extends React.Component {
  state = {
    activePage: this.props.activePage,
  };

  static defaultProps = {
    itemsCountPerPage: 20,
    pageRangeDisplayed: 5,
    activePage: 1,
  };

  onChange = pageNumber => {
    this.setState({ activePage: pageNumber });
    this.props.onChange(pageNumber);
  };

  render() {
    const {
      totalItemsCount,
      itemsCountPerPage,
      pageRangeDisplayed,
    } = this.props;

    const { activePage } = this.state;

    return (
      <div>
        <Pagination
          totalItemsCount={totalItemsCount}
          activePage={activePage}
          itemsCountPerPage={itemsCountPerPage}
          pageRangeDisplayed={pageRangeDisplayed}
          onChange={this.onChange}
          innerClass="c-pagination"
          itemClass="c-pagination__item"
          activeClass="c-pagination__item--active"
          activeLinkClass="c-pagination__item__link--active"
          linkClassFirst="c-pagination__item__link--first"
          linkClassLast="c-pagination__item__link--last"
          linkClassNext="c-pagination__item__link--next"
          linkClassPrev="c-pagination__item__link--prev"
        />
      </div>
    );
  }
}

export default Paginator;
